import { useNavigate } from "react-router"
import { Button } from "@/components/ui/button"
import { Plus, Settings } from "lucide-react"

const DashboardHeader = () => {
  const navigate = useNavigate()

  return (
    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-8">
      <div>
        <h1 className="text-3xl font-bold text-foreground">School Dashboard</h1>
        <p className="text-muted-foreground mt-1">Monitor school performance and student engagement</p>
      </div>

      <div className="flex gap-3">
        <Button
          onClick={() => navigate("/students-management")}
          className="bg-primary hover:bg-primary/90 text-white gap-2"
        >
          <Plus className="w-4 h-4" />
          Add Student
        </Button>
        <Button
          onClick={() => navigate("/class-management")}
          variant="outline"
          className="gap-2 bg-transparent"
        >
          <Settings className="w-4 h-4" />
          Manage Classes
        </Button>
      </div>
    </div>
  )
}

export default DashboardHeader